// 请求头
let baseURL = '', headUrl;
const { REACT_APP_ENV } = process.env;
if(REACT_APP_ENV === 'dev') {
  // baseURL = 'https://testwebapi.teanet.com';
  baseURL = 'http://teanet_website_api.test';
  headUrl = "http://static.me/teanet_website";
}
else if(REACT_APP_ENV === 'uat') {
  baseURL = 'https://testwebapi.teanet.com';
  headUrl = "https://statictest.efuton.com/teanet_website";
}
else if(REACT_APP_ENV === 'pro') {
  baseURL = 'https://webapi.teanet.com';
  headUrl = "https://static.teanet.com/teanet_website";
}

export { baseURL, headUrl };

 // 请求返回的状态码
export const SUCCESS_CODE = 0;
export const FAILURE_CODE = -1;

// 分页条默认页数
export const default_page_size = ['30', '60', '90', '120'];
